export default "__VITE_ASSET__DC75spQb__"